import {noop} from '@priority-software/priority-style-react';
import {mayDesignForm} from '../../../utils/designUtils';
import {ContextMenuTextColor} from '../types';
import {texts} from '../../AdvancedSearch/AdvancedSearchDrawer/texts';

type ContextMenuDataHandlers = {
    helpFieldFunc?: () => Promise<void> | void;
    designFunc?: () => Promise<void> | void;
    openFormDesignFunc?: () => Promise<void> | void;
    restoreColumnWidthFunc?: () => Promise<void> | void;
    defineRecordColorFunc?: () => Promise<void> | void;
    showCurrentRecordColorsFunc?: () => Promise<void> | void;
    noOfFormRowsFunc?: () => Promise<void> | void;
    searchByFieldFunc?: () => Promise<void> | void;
    moveEditFunc?: () => Promise<void> | void;
    specialCopyPasteFunc?: () => Promise<void> | void;
    copySaveToBufferFunc?: () => Promise<void> | void;
    pasteFromBufferFunc?: () => Promise<void> | void;
    storeRecordsFunc?: () => Promise<void> | void;
    retrieveRecordsFunc?: () => Promise<void> | void;
    hideRecordFunc?: () => Promise<void> | void;
    clearAllFunc?: () => Promise<void> | void;
    deleteFunc?: () => Promise<void> | void;
};
export const useContextMenuData = ({
    helpFieldFunc = noop,
    designFunc = noop,
    openFormDesignFunc = noop,
    restoreColumnWidthFunc = noop,
    defineRecordColorFunc = noop,
    showCurrentRecordColorsFunc = noop,
    noOfFormRowsFunc = noop,
    searchByFieldFunc = noop,
    moveEditFunc = noop,
    specialCopyPasteFunc = noop,
    copySaveToBufferFunc = noop,
    pasteFromBufferFunc = noop,
    storeRecordsFunc = noop,
    retrieveRecordsFunc = noop,
    hideRecordFunc = noop,
    clearAllFunc = noop,
    deleteFunc = noop
}: ContextMenuDataHandlers) => {
    return [
        {
            name: texts.ctxMenuFieldHelpLabel,
            shortCode: '[F1]',
            onClick: helpFieldFunc
        },
        {
            name: texts.ctxMenuDesignLabel,
            onClick: mayDesignForm() ? designFunc : noop,
            subMenu: [
                {
                    name: texts.ctxMenuFormDesignLabel,
                    shortCode: '[Ctrl+B]',
                    onClick: openFormDesignFunc
                },
                {
                    name: texts.ctxMenuRestoreColWidthLabel,
                    planning: true,
                    onClick: restoreColumnWidthFunc
                },
                {
                    name: texts.ctxMenuDefineRecordColorLabel,
                    planning: true,
                    onClick: defineRecordColorFunc
                },
                {
                    name: texts.ctxMenuShowCurrRecordColorsLabel,
                    planning: true,
                    onClick: showCurrentRecordColorsFunc
                },
                {name: texts.ctxMenuNoOfRowsLabel, onClick: noOfFormRowsFunc, hidden: true}
            ],
            hidden: !mayDesignForm()
        },
        {
            name: texts.ctxMenuSearchByFieldLabel,
            shortCode: '[Ctrl+F3]',
            onClick: searchByFieldFunc
        },
        {
            name: texts.ctxMenuMoveAndEditLabel,
            shortCode: '[F2]',
            onClick: moveEditFunc
        },
        {
            name: texts.ctxMenuSpecialCopyPasteLabel,
            onClick: specialCopyPasteFunc,
            subMenu: [
                {
                    name: texts.ctxMenuCopySaveBufferLabel,
                    shortCode: '[Ctrl+F9]',
                    onClick: copySaveToBufferFunc,
                    planning: true
                },
                {
                    name: texts.ctxMenuPasteFromBufferLabel,
                    shortCode: '[F9]',
                    onClick: pasteFromBufferFunc,
                    planning: true
                },
                {name: texts.ctxMenuStoreRecordsLabel, onClick: storeRecordsFunc, planning: true},
                {
                    name: texts.ctxMenuRetrieveRecordsLabel,
                    onClick: retrieveRecordsFunc,
                    planning: true
                }
            ]
        },
        {
            name: texts.ctxMenuHideRecordLabel,
            shortCode: '[F7]',
            onClick: hideRecordFunc,
            hidden: false
        },
        {
            name: texts.ctxMenuClearAllLabel,
            shortCode: '[Ctrl+F7]',
            onClick: clearAllFunc,
            hidden: false
        },
        {
            name: texts.ctxMenuDeleteLabel,
            shortCode: '[Ctrl+Delete]',
            color: ContextMenuTextColor.black,
            divider: true,
            onClick: deleteFunc,
            hidden: false
        }
    ].filter(item => !item.hidden);
};
